enum SCAN_STATUS {
    IN_PROGRESS = 'running',
    FINISHED = 'ready',
}

export default SCAN_STATUS;
